import { useContext } from "react";
import LoadingContext from "./LoadingContext";

export const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error(
      "useLoadingContext deve ser usado dentro de um LoadingProvider",
    );
  }

  const createLoadingHandler = (key: string) => ({
    isLoading: context.loadingStates[key] || false,
    setLoading: (loading: boolean) => context.setLoadingState(key, loading),
  });

  return {
    ...context,
    createLoadingHandler,
  };
};
